/**
 * 使い方のマスター（分類 → 質問 → 答え）
 *
 * 正は `frontend/content/help/help-master.json`。AI アシスタントの「使い方を聞く」と
 * `/help` ページがこれを表示する（AI を使わない）。木に無い質問だけ、チャットの Lambda が
 * 同じファイル（パッケージを作るときにコピー）を根拠に AI で答える。
 * 機能を変えたら、更新履歴と同じコミットでここも見直す（CLAUDE.md）。
 */

import rawHelpMaster from '../../content/help/help-master.json';

export interface HelpLink {
  label: string;
  /** サイト内のパス（/ で始まる） */
  path: string;
}

export interface HelpItem {
  id: string;
  question: string;
  answer: string;
  links?: HelpLink[];
  /** この答えが説明している機能紹介ページの slug */
  features?: string[];
}

export interface HelpCategory {
  id: string;
  label: string;
  description?: string;
  items: HelpItem[];
}

export interface HelpMaster {
  version: number;
  updatedAt?: string;
  categories: HelpCategory[];
}

export const HELP_MASTER = rawHelpMaster as unknown as HelpMaster;
